export const getArrowSize = (size, placement, x, y) => {
    const staticSide = {
        top: 'bottom',
        right: 'left',
        bottom: 'top',
        left: 'right',
    }[placement.split('-')[0]];
    return {
        width: size,
        height: size,
        left: x != null ? `${x}px` : '',
        top: y != null ? `${y}px` : '',
        right: '',
        bottom: '',
        [staticSide]: `calc(-${size}px / 2)`,
    };
};
export const composeRefs = (...refs) => (x) => refs
    .filter((r) => !!r)
    .forEach((ref) => {
    if (typeof ref === 'function') {
        ref(x);
    }
    else {
        ref.current = x;
    }
});
//# sourceMappingURL=utils.js.map